import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams, HttpHeaders } from '@angular/common/http';
import { ApiService } from '../api/api.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ThreadService {

  constructor( private http: HttpClient, private apiUrl: ApiService) { }

  // Thread Field API
  apiGetThreadFields(data,apiVersion = 1) {
    switch(apiVersion) {
      case 1:
      if(data.domainId == 7){
        const params = new HttpParams()
      .set('apiKey', data.apiKey)
      .set('domainId', data.domainId)
      .set('countryId', data.countryId)
      .set('userId', data.userId)
      .set('step', data.step)
      .set('threadCategoryId', data.threadCategoryId)
      .set('threadType', data.threadType)
      .set('docType', data.docType)
      .set('threadId', data.threadId)
      .set('platform', data.platform)
      .set('apiType', data.apiType)
      .set('makeName', data.makeName)
      .set('modelName', data.modelName)
      .set('yearValue', data.yearValue)
      .set('productType', data.productType)
      .set('isMainSection', data.isMainSection)
      .set('threadCategoryValue', data.threadCategoryValue)
      .set('workstreamId', data.workstramId)
      .set('version', data.version)
      .set('dealerCode', data.dealerCode);
      const body = JSON.stringify(data);
      return this.http.get<any>(this.apiUrl.apiGetThreadFields(apiVersion), {'params': params});
      }
      else{
        const params = new HttpParams()
        .set('apiKey', data.apiKey)
        .set('domainId', data.domainId)
        .set('countryId', data.countryId)
        .set('userId', data.userId)
        .set('step', data.step)
        .set('threadCategoryId', data.threadCategoryId)
        .set('threadType', data.threadType)
        .set('docType', data.docType)
        .set('threadId', data.threadId)
        .set('platform', data.platform)
        .set('apiType', data.apiType)
        .set('makeName', data.makeName)
        .set('modelName', data.modelName)
        .set('yearValue', data.yearValue)
        .set('productType', data.productType)
        .set('isMainSection', data.isMainSection)
        .set('threadCategoryValue', data.threadCategoryValue)
        .set('workstreamId', data.workstramId)
        .set('version', data.version)
        const body = JSON.stringify(data);
        return this.http.get<any>(this.apiUrl.apiGetThreadFields(apiVersion), {'params': params});
      }
        break;
      case 2:
        return this.http.post<any>(this.apiUrl.apiGetThreadFields(apiVersion), data);
        break;
    }
  }

  // Opportunity Field API
  apiGetOpportunityFields(data) {
    const params = new HttpParams()
      .set('apiKey', data.apiKey)
      .set('domainId', data.domainId)
      .set('userId', data.userId)
      .set('step', data.step)
      .set('apiType', data.apiType);
    const body = JSON.stringify(data);

    return this.http.get<any>(this.apiUrl.apiGetOpportunityFields(), {'params': params});
  }

  apiSendMessageToSlack(data) {

    return this.http.post<any>(this.apiUrl.apiSendMessageToSlack(), data);

  }

  apiGetMarketPlaceFields(data: any) {
    const params = new HttpParams()
      .set('apiKey', data.apiKey)
      .set('domainId', data.domainId)
      .set('countryId', data.countryId)
      .set('userId', data.userId)
      .set('step', data.step)
      .set('threadCategoryId', data.threadCategoryId)
      .set('threadType', data.threadType)
      .set('docType', data.docType)
      .set('id', data.threadId)
      .set('platform', data.platform)
      .set('apiType', data.apiType)
      .set('makeName', data.makeName)
      .set('modelName', data.modelName)
      .set('yearValue', data.yearValue)
      .set('productType', data.productType);
    return this.http.get<any>(this.apiUrl.apiGetMarketPlaceFields(), {'params': params});
  }

  apiGetAllManuals(domainId, isFront, search) {
    const params = new HttpParams()
      .set('isFront', isFront)
      .set('search', search)
      .set('domainId', domainId);
    return this.http.get<any>(this.apiUrl.apiGetAllManuals(), {'params': params});
  }

  apiGetAllManualsTitle(domainId) {
    const params = new HttpParams()
      .set('domainId', domainId);
    return this.http.get<any>(this.apiUrl.apiGetAllManualsTitle(), { 'params': params });
  }

  apiGetAllTrainingsTitle(domainId){
    const params = new HttpParams()
    .set('domainId', domainId);
  return this.http.get<any>(this.apiUrl.apiGetAllTrainingsTitle(), { 'params': params });
  }

  apiGetAllVideosTitle(domainId){
    const params = new HttpParams()
    .set('domainId', domainId);
  return this.http.get<any>(this.apiUrl.apiGetAllVideosTitle(), { 'params': params });
  }

  apiGetAllItemNumber(domainId){
    const params = new HttpParams()
    .set('domainId', domainId);
  return this.http.get<any>(this.apiUrl.apiGetAllItemNumber(), { 'params': params });
  }

  apiGetAllTrainingscodeClassList(){
  return this.http.get<any>(this.apiUrl.apiGetAllTrainingscodeClassList());
  }

  apiGetAllRepots(domainId, limit, offset, sortFieldEvent?,sortorderEvent?,dataFilterEvent?,dateFilters?, reportId?, companyId?) {
    const params = new HttpParams()
      .set('domainId', domainId)
      .set('limit', limit)
      .set('offset', offset)
      .set('sortFieldEvent', sortFieldEvent ? sortFieldEvent: '' )
      .set('sortorderEvent', sortorderEvent ? sortorderEvent: '' )
      .set('dataFilterEvent', dataFilterEvent ? dataFilterEvent: '' )
      .set('reportId', reportId ? reportId: 0 )
      .set('companyId', companyId ? companyId: '' )
      .set('startDate', dateFilters?.startDate ? dateFilters?.startDate: '' )
      .set('endDate', dateFilters?.endDate ? dateFilters?.endDate: '' )
      .set('offsetInMinutes', dateFilters?.offsetInMinutes ? dateFilters?.offsetInMinutes: '' )
    return this.http.get<any>(this.apiUrl.apiGetAllReports(), {'params': params});
  }
  
  apiGetMarketTrainingsReport(domainId, limit, offset, sortFieldEvent?,sortorderEvent?,dataFilterEvent?,dateFilters?, reportId?, companyId?) {
    const params = new HttpParams()
      .set('domainId', domainId)
      .set('limit', limit)
      .set('offset', offset)
      .set('sortFieldEvent', sortFieldEvent ? sortFieldEvent: '' )
      .set('sortorderEvent', sortorderEvent ? sortorderEvent: '' )
      .set('dataFilterEvent', dataFilterEvent ? dataFilterEvent: '' )
      .set('reportId', reportId ? reportId: 0 )
      .set('companyId', companyId ? companyId: '' )
      .set('dateType', dateFilters?.fields ? dateFilters?.fields: '' )
      .set('startDate', dateFilters?.startDate ? dateFilters?.startDate: '' )
      .set('endDate', dateFilters?.endDate ? dateFilters?.endDate: '' )
      .set('offsetInMinutes', dateFilters?.offsetInMinutes ? dateFilters?.offsetInMinutes: '' )
    return this.http.get<any>(this.apiUrl.apiGetMarketTrainingsReport(), {'params': params});
  }

  apiShopPaymentReport(domainId, limit, offset, sortFieldEvent?,sortorderEvent?,dataFilterEvent?,dateFilters?, reportId?, companyId?) {
    const params = new HttpParams()
      .set('domainId', domainId)
      .set('limit', limit)
      .set('offset', offset)
      .set('sortFieldEvent', sortFieldEvent ? sortFieldEvent: '' )
      .set('sortorderEvent', sortorderEvent ? sortorderEvent: '' )
      .set('dataFilterEvent', dataFilterEvent ? dataFilterEvent: '' )
      .set('reportId', reportId ? reportId: 0 )
      .set('companyId', companyId ? companyId: '' )
      .set('startDate', dateFilters?.startDate ? dateFilters?.startDate: '' )
      .set('endDate', dateFilters?.endDate ? dateFilters?.endDate: '' )
      .set('offsetInMinutes', dateFilters?.offsetInMinutes ? dateFilters?.offsetInMinutes: '' )
    return this.http.get<any>(this.apiUrl.apiGetAllPurchaseHistory(), {'params': params});
  }


  apiGetVisionRepots(limit, offset, sortFieldEvent?,sortorderEvent?,dataFilterEvent?, reportId?, companyId?,) {
    const params = new HttpParams()
      .set('limit', limit)
      .set('offset', offset)
      .set('sortFieldEvent', sortFieldEvent ? sortFieldEvent: '' )
      .set('sortorderEvent', sortorderEvent ? sortorderEvent: '' )
      .set('dataFilterEvent', dataFilterEvent ? dataFilterEvent: '' )
      .set('reportId', reportId ? reportId: 0 )
      .set('companyId', companyId ? companyId: '' )
    return this.http.get<any>(this.apiUrl.apiGetVisionReports(), {'params': params});
  }


  reportsColumns(data: any) {
    return this.http.post<any>(this.apiUrl.apiForReportsColumns(), data);
  }

  apiGetAllQuickBookReports(domainId, limit, offset) {
    const params = new HttpParams()
      .set('domainId', domainId)
      .set('limit', limit)
      .set('offset', offset)
    return this.http.get<any>(this.apiUrl.apiGetAllQuickBookReports(), {'params': params});
  }

  apiGetAllSubscriptionReports(data) {
    const params = new HttpParams()
      .set('domainId', data.domainId)
      .set('limit', data.limit)
      .set('offset', data.offset)
      .set('sortFieldEvent', data.sortFieldEvent || '')
      .set('sortOrderField', data.sortOrderField || '')
      .set('dataFilterEvent', data.dataFilterEvent || '')
    return this.http.get<any>(this.apiUrl.apiGetAllSubscriptionReports(), {'params': params});
  }
  apiGetManualFields(data: any) {
    const params = new HttpParams()
      .set('apiKey', data.apiKey)
      .set('domainId', data.domainId)
      .set('countryId', data.countryId)
      .set('userId', data.userId)
      .set('step', data.step)
      .set('threadCategoryId', data.threadCategoryId)
      .set('threadType', data.threadType)
      .set('docType', data.docType)
      .set('id', data.threadId)
      .set('platform', data.platform)
      .set('apiType', data.apiType)
      .set('makeName', data.makeName)
      .set('modelName', data.modelName)
      .set('yearValue', data.yearValue)
      .set('productType', data.productType);
    return this.http.get<any>(this.apiUrl.apiGetManualFields(), {'params': params});
  }

  apiGetSalesPersonData(id: any, domainId: any) {
    const params = new HttpParams()
    .set('id', id)
    .set('domainId', domainId);
    return this.http.get<any>(this.apiUrl.apiGetSalesUserData(), {'params': params});
  }

  apiGetManualSalesPersonData(id: any, domainId: any) {
    const params = new HttpParams()
    .set('id', id)
    .set('domainId', domainId);
    return this.http.get<any>(this.apiUrl.apiGetmanualSalesUserData(), {'params': params});
  }

  apiGetParticipantData(id: any, domainId: any) {
    const params = new HttpParams()
    .set('id', id)
    .set('domainId', domainId);
    return this.http.get<any>(this.apiUrl.apiGetParticipantsData(), {'params': params});
  }

  apiGetMarketPlaceEditData(data: any) {
    const params = new HttpParams()
      .set('apiKey', data.apiKey)
      .set('domainId', data.domainId)
      .set('countryId', data.countryId)
      .set('userId', data.userId)
      .set('id', data.threadId)
      .set('platform', data.platform)
      .set('apiType', data.apiType);
    return this.http.get<any>(this.apiUrl.apiGetMarketPlaceEditData(), {'params': params});
  }

  apiGetManualEditData(data: any) {
    const params = new HttpParams()
      .set('apiKey', data.apiKey)
      .set('domainId', data.domainId)
      .set('countryId', data.countryId)
      .set('userId', data.userId)
      .set('id', data.threadId)
      .set('platform', data.platform)
      .set('apiType', data.apiType);
    return this.http.get<any>(this.apiUrl.apiGetManualEditData(), {'params': params});
  }

  apiGetMarketPlaceReminderData(data: any) {
    const params = new HttpParams()
      .set('apiKey', data.apiKey)
      .set('domainId', data.domainId)
      .set('countryId', data.countryId)
      .set('userId', data.userId)
      .set('id', data.threadId)
      .set('platform', data.platform)
      .set('apiType', data.apiType);
    return this.http.get<any>(this.apiUrl.apiGetMarketPlaceReminderData(), {'params': params});
  }

  apiGetMarketPlaceRegisterUserData(data: any) {
    const params = new HttpParams()
    .set('apiKey', data.apiKey)
    .set('domainId', data.domainId)
    .set('countryId', data.countryId)
    .set('userId', data.userId)
    .set('id', data.threadId)
    .set('platform', data.platform)
    .set('apiType', data.apiType)
    .set('registered', data?.registered ? '1' : '')
    .set('filter', data.status);
    return this.http.get<any>(this.apiUrl.apiGetMarketPlaceRegisterUserData(), {'params': params});
  }

  apiGetMarketPlaceManualUserData(data: any) {
    const params = new HttpParams()
    .set('apiKey', data.apiKey)
    .set('domainId', data.domainId)
    .set('countryId', data.countryId)
    .set('userId', data.userId)
    .set('id', data.threadId)
    .set('platform', data.platform)
    .set('apiType', data.apiType)
    .set('filter', data.status);
    return this.http.get<any>(this.apiUrl.apiGetMarketPlaceManualUserData(), {'params': params});
  }

  apiForRefundPayment(paymentData: any) {
    return this.http.post<any>(this.apiUrl.apiForRefundPayment(), paymentData);
  }

  refundResendEmail(paymentData: any) {
    return this.http.post<any>(this.apiUrl.refundResendEmail(), paymentData);
  }

  apiForRefundManualPayment(paymentData: any) {
    return this.http.post<any>(this.apiUrl.apiForRefundManualPayment(), paymentData);
  }

  apiForPartialRefundPayment(paymentData: any) {
    return this.http.post<any>(this.apiUrl.apiForPartialRefundPayment(), paymentData);
  }

  apiForRefundHistory(data: any) {
    const params = new HttpParams()
    .set('id', data.id)
    .set('typeId', data.typeId || null);
    return this.http.get<any>(this.apiUrl.apiForRefundHistory(), { 'params': params });
  }

  apiForCustomerAdd(customerData: any) {
    return this.http.post<any>(this.apiUrl.apiForCustomerAdd(), customerData);
  }

  apiForCompanyAdd(companyData: any) {
    return this.http.post<any>(this.apiUrl.apiForCompanyAdd(), companyData);
  }

  apiForCompanyAddData(domainId: any) {
    const params = new HttpParams()
    .set('domainId', domainId);
    return this.http.get<any>(this.apiUrl.apiForCompanyAddData(), {'params': params});
  }

  apiForCompanyAddressAddData(data: any) {
    const params = new HttpParams()
    .set('domainId', data.domainId)
    .set('companyId', data.companyId);
    return this.http.get<any>(this.apiUrl.apiForCompanyAddressAddData(), {'params': params});
  }

  apiForCompanyAddressAddDataId(data: any) {
    const params = new HttpParams()
    .set('domainId', data.domainId)
    .set('companyId', data.companyId);
    return this.http.get<any>(this.apiUrl.apiForCompanyAddressAddDataId(), {'params': params});
  }

  apiForCompanyAddressUpdate(data: any) {
    return this.http.post<any>(this.apiUrl.apiForCompanyAddressUpdate(), data);
  }


  apiForimportShopData(fdata: any){
    const formData: FormData = new FormData();
    formData.append('file', fdata.file);
    formData.append('domainId', fdata.domainId);
    formData.append('userId', fdata.userId);
    formData.append('apiKey', fdata.apiKey);
    return this.http.post(this.apiUrl.apiImportStoreList(), formData, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }

  apiForUploadCustomerData(payload: any){
    const formData: FormData = new FormData();
    formData.append('file', payload.file);
    formData.append('deleteFlag', payload.deleteFlag);
    formData.append('domainId', payload.domainId);
    formData.append('userId', payload.userId);
    return this.http.post(this.apiUrl.apiForCustomerFileUpload(), formData, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }

  errorMgmt(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }

  apiForCustomerUpdate(customerData: any) {
    return this.http.post<any>(this.apiUrl.apiForCustomerUpdate(), customerData);
  }

  apiForCustomerDelete(id: any, domainId: any) {
    const params = new HttpParams()
      .set('id', id)
      .set('domainId', domainId);
    return this.http.delete<any>(this.apiUrl.apiForCustomerDelete(), { params: params });
  }

  apiInnerGetMarketPlaceEditData(data: any) {
    const params = new HttpParams()
      .set('id', data.threadId);
    return this.http.get<any>(this.apiUrl.apiGetMarketPlaceEditData(), {'params': params});
  }

  apiInnerGetManualEditData(data: any) {
    const params = new HttpParams()
      .set('id', data.threadId);
    return this.http.get<any>(this.apiUrl.apiGetManualEditData(), {'params': params});
  }

  apiMarketPlaceEditDomainData(data: any) {
    const params = new HttpParams()
      .set('id', data.id)
      .set('domainId', data.domainId);
    return this.http.get<any>(this.apiUrl.apiGetMarketPlaceEditDomainData(), {'params': params});
  }

  apiMarketPlacePoliciesData(data) {
    const params = new HttpParams()
    .set('domainId', data)
    return this.http.get<any>(this.apiUrl.apiGetMarketPlacePoliciesData(), {'params': params});
  }

  apiMarketPlacePoliciesDataByType(data, domainId: any){
    const params = new HttpParams()
    .set('type', data)
    .set('domainId', domainId);
    return this.http.get<any>(this.apiUrl.apiGetMarketPlacePoliciesDataByType(), {'params': params});
  }

  apiMarketPlacePolicyData(data: any) {
    const params = new HttpParams()
      .set('domainId', data.domainId)
      .set('policyId', data.policyId);
    return this.http.get<any>(this.apiUrl.apiGetMarketPlacePolicyData(), {'params': params});
  }

  updateMarketPlacePolicyData(data: any) {
    return this.http.post<any>(this.apiUrl.apiUpdateMarketPlacePolicyData(), data);
  }

  deleteMarketPlacePolicy(data: any) {
    return this.http.post<any>(this.apiUrl.apiDeleteMarketPlacePolicy(), data);
  }

  getCityStateData(data: any) {
    return this.http.post<any>(this.apiUrl.getCityStateData(), data);
  }

  apiMarketPlaceEditDomainBannerData(data: any) {
    const params = new HttpParams()
      .set('id', data.id)
      .set('domainId', data.id);
    return this.http.get<any>(this.apiUrl.apiGetMarketPlaceEditDomainBannerData(), {'params': params});
  }

  apiMarketPlacePolicyHistory(id: any, domainId: any) {
    const params = new HttpParams()
      .set('policyId', id)
      .set('domainId', domainId);
    return this.http.get<any>(this.apiUrl.apiGetMarketPlacePolicyHistory(), {'params': params});
  }

  apigetQuizSingleData(id: any) {
    const params = new HttpParams()
      .set('id', id);
    return this.http.get<any>(this.apiUrl.apiGetQuizEditData(), {'params': params});
  }

  apigetTopicSingleData(id: any) {
    const params = new HttpParams()
      .set('id', id);
    return this.http.get<any>(this.apiUrl.apiGetTopicEditData(), {'params': params});
  }

  apiGetMarketPlaceData(data: any) {
    if (data.domainId && data.fromTechDomain==1)
      {
        let isFront='false';
        const params = new HttpParams()
        .set('limit', data.limit)
        .set('offset', data.offset)
        .set('domainId', data.domainId)
        .set('filter', data.currentFilter ? data.currentFilter : '')
        .set('trainingStatus', data.trainingStatus ? data.trainingStatus : '')
        .set('startDate', data.startDate ? data.startDate : '')
        .set('endDate', data.endDate ? data.endDate : '')
        .set('state', data.state ? data.state : '')
        .set('search', data.search ? data.search : '')
        .set('keyword', data.keyword ? data.keyword : '')
        .set('fromTechDomain', data.fromTechDomain ? data.fromTechDomain : '')
        .set('trainingType', data.trainingType ? data.trainingType : '')
        .set('trainingModes', data.trainingModes ? data.trainingModes : '')
        .set('timings', data.timings ? data.timings : '')
        .set('userId', data.userId ? data.userId : '')
        .set('isFront', isFront)
        .set('sortFieldEvent', data.sortFieldEvent ? data.sortFieldEvent : '')
        .set('sortOrderField', data.sortOrderField ? data.sortOrderField : '')
        .set('dataFilterEvent', data.dataFilterEvent ? data.dataFilterEvent : '');
      let url = this.apiUrl.apiGetMarketPlaceData();
      if (data.domainId && data.fromTechDomain!=1) {
        url = this.apiUrl.apiGetDomainMarketPlaceData();
      }
      return this.http.get<any>(url, {'params': params});
      }
      else
      {
        const params = new HttpParams()
        .set('limit', data.limit)
        .set('offset', data.offset)
        .set('domainId', data.domainId)
        .set('filter', data.currentFilter ? data.currentFilter : '')
        .set('trainingStatus', data.trainingStatus ? data.trainingStatus : '')
        .set('startDate', data.startDate ? data.startDate : '')
        .set('endDate', data.endDate ? data.endDate : '')
        .set('state', data.state ? data.state : '')
        .set('search', data.search ? data.search : '')
        .set('keyword', data.keyword ? data.keyword : '')
        .set('trainingType', data.trainingType ? data.trainingType : '')
        .set('trainingModes', data.trainingModes ? data.trainingModes : '')
        .set('timings', data.timings ? data.timings : '')
        .set('isFront', data.isFront ? data.isFront : false)
        .set('domainTraining', data.domainTraining ? data.domainTraining : false)
        .set('sortFieldEvent', data.sortFieldEvent ? data.sortFieldEvent : '')
        .set('sortOrderField', data.sortOrderField ? data.sortOrderField : '')
        .set('dataFilterEvent', data.dataFilterEvent ? data.dataFilterEvent : '')
        .set('miles', data.miles ? data.miles : '')
        .set('lat', data.lat ? data.lat : '')
        .set('lng', data.lng ? data.lng : '')
        .set('purchaseType', data.purchaseType ? data.purchaseType : '')
        .set('allDomains', data.allDomains ? data.allDomains : '');
      let url = this.apiUrl.apiGetMarketPlaceData();
      if (data.domainId) {
        url = this.apiUrl.apiGetDomainMarketPlaceData();
      }

         return this.http.get<any>(url, {'params': params});
      }


  }

  apiGetManualsData(data: any) {
    const params = new HttpParams()
      .set('limit', data.limit)
      .set('offset', data.offset)
      .set('domainId', data.domainId)
      .set('filter', data.currentFilter ? data.currentFilter : '')
      .set('trainingStatus', data.trainingStatus ? data.trainingStatus : '')
      .set('startDate', data.startDate ? data.startDate : '')
      .set('endDate', data.endDate ? data.endDate : '')
      .set('state', data.state ? data.state : '')
      .set('search', data.search ? data.search : '')
      .set('keyword', data.keyword ? data.keyword : '')
      .set('isFront', data.isFront ? data.isFront : false)
      .set('sortFieldEvent', data.sortFieldEvent || '')
      .set('sortOrderField', data.sortOrderField || '')
      .set('status', data.status ? data.status : '')
      .set('dataFilterEvent', data.dataFilterEvent || '');
    let url = this.apiUrl.apiGetManualData();
    return this.http.get<any>(url, {'params': params});
  }

  apiRepairfyDomainData(data: any) {
    const params = new HttpParams()
      .set('domainId', data.domainId);
    return this.http.get<any>(this.apiUrl.apiRepairfyDomainData(), {'params': params});
  }

  apiGetQuizData(data: any) {
    let params = new HttpParams()
      .set('limit', data.limit)
      .set('offset', data.offset)
      .set('domainId', data.domainId);
    if (data.topic_id) {
      console.log("data.topic_id: ", data.topic_id);
      params = params.append('topic_id', data.topic_id);
    }
    let url = this.apiUrl.apiGetQuizData();
    if (data.domainId) {
      url = this.apiUrl.apiGetDomainQuizData();
    }
    return this.http.get<any>(url, {'params': params});
  }

  apiGetAllCustomerData(data: any) {
    let params = new HttpParams()
      .set('limit', data.limit)
      .set('offset', data.offset)
      .set('domainId', data.domainId);
    return this.http.get<any>(this.apiUrl.apiGetAllCustomerData(), {'params': params});
  }

  apiGetAllCustomerUsers(data: any) {
    let params = new HttpParams()
      .set('limit', data.limit)
      .set('offset', data.offset)
      .set('domainId', data.domainId)
      .set('userEmail', data.userEmail);
    return this.http.get<any>(this.apiUrl.apiGetAllCustomerUsers(), {'params': params});
  }

  apiGetBusinessData(data: any) {
    let params = new HttpParams()
      .set('domainId', data.domainId)
      .set('type', data.type)
      .set('value', data.value);
    return this.http.get<any>(this.apiUrl.apiGetBusinessData(), { 'params': params });
  }

  apiGetMarketPlaceDataWithDomainName(data: any) {
    const params = new HttpParams()
      .set('limit', data.limit)
      .set('offset', data.offset)
      .set('domainName', data.domainName)
      .set('filter', data.currentFilter ? data.currentFilter : '')
      .set('startDate', data.startDate ? data.startDate : '')
      .set('endDate', data.endDate ? data.endDate : '')
      .set('state', data.state ? data.state : '')
      .set('search', data.search ? data.search : '')
      .set('keyword', data.keyword ? data.keyword : '')
      .set('isFront', data.isFront ? data.isFront : false);
    let url = this.apiUrl.apiGetMarketPlaceDataWithDomainName();
    return this.http.get<any>(url, {'params': params});
  }

  apiGetManualsDataWithDomainName(data: any) {
    const params = new HttpParams()
      .set('limit', data.limit)
      .set('offset', data.offset)
      .set('domainName', data.domainName)
      .set('domainId', data.domainId)
      .set('filter', data.currentFilter ? data.currentFilter : '')
      .set('startDate', data.startDate ? data.startDate : '')
      .set('endDate', data.endDate ? data.endDate : '')
      .set('state', data.state ? data.state : '')
      .set('search', data.search ? data.search : '')
      .set('keyword', data.keyword ? data.keyword : '')
      .set('isFront', data.isFront ? data.isFront : false);
    let url = this.apiUrl.apiGetManualDataWithDomainName();
    return this.http.get<any>(url, {'params': params});
  }

  apiForUpdateSalesPerson(data: any) {
    return this.http.post(this.apiUrl.apiUpdateSalesPersonApi(), data);
  }

  apiGetVideoCategories(data: any) {
    return this.http.post(this.apiUrl.apiGetVideoCategories(), data);
  }

  apiGetVideosByCategory(data: any) {
    return this.http.post(this.apiUrl.apiGetVideosByCategory(), data);
  }

  apiRemoveVideo(data: any) {
    return this.http.post(this.apiUrl.apiRemoveVideo(), data);
  }

  apiGetVideo(data: any) {
    return this.http.post(this.apiUrl.apiGetVideo(), data);
  }

  apiForUpdateComment(data: any) {
    return this.http.post(this.apiUrl.apiUpdateComment(), data);
  }

  apiForUpdatemanualComment(data: any) {
    return this.http.post(this.apiUrl.apiUpdateManualComment(), data);
  }

  apiForUpdateManualSalesPerson(data: any) {
    return this.http.post(this.apiUrl.apiUpdateManualSalesPersonApi(), data);
  }

  apiGetDomainsData(data: any) {
    const params = new HttpParams()
      .set('limit', data.limit)
      .set('domainId', data.domainId)
      .set('offset', data.offset)
      .set('field', data?.field ? data.field : '');
    return this.http.get<any>(this.apiUrl.apiGetDomainsData(), {'params': params});
  }

  createMarketPlace(marketPlaceData: any) {
    return this.http.post<any>(this.apiUrl.apiCreateMarketPlace(), marketPlaceData);
  }

  createManagevideolibrary(marketPlaceData: any) {
    return this.http.post<any>(this.apiUrl.apiCreateManagevideolibrary(), marketPlaceData);
  }

  apiManageVideoView(marketPlaceData: any) {
    return this.http.post<any>(this.apiUrl.apiManageVideoView(), marketPlaceData);
  }

  createMarketPlaceManual(marketPlaceData: any) {
    return this.http.post<any>(this.apiUrl.apiCreateMarketPlaceManual(), marketPlaceData);
  }

  createQuizTopic(quizTopic: any) {
    return this.http.post<any>(this.apiUrl.apiCreateQuizTopic(), quizTopic);
  }

  updateQuizTopic(quizTopic: any) {
    return this.http.post<any>(this.apiUrl.apiUpdateQuizTopic(), quizTopic);
  }

  apiForZoomSettingUpdate(data){
    return this.http.post<any>(this.apiUrl.apiForZoomSettingUpdate(), data);
  }

  apiForInformedUsersUpdate(data){
    return this.http.post<any>(this.apiUrl.apiForInformedUsersUpdate(), data);
  }

  apiForNotificationSettingUpdate(data){
    return this.http.post<any>(this.apiUrl.apiForNotificationSettingUpdate(), data);
  }

  apiForZoomConfigurationUpdate(data){
    return this.http.post<any>(this.apiUrl.apiForZoomConfigurationUpdate(), data);
  }
  apiForMarketplaceSettingsUpdate(data){
    return this.http.post<any>(this.apiUrl.apiForMarketplaceSettingsUpdate(), data);
  }

  apiForLoadZoomSetting(domainId){
    const params = new HttpParams()
      .set('domainId', domainId);
    return this.http.get<any>(this.apiUrl.apiForLoadZoomSetting(), {'params': params});
  }

  apiForLoadMarketplaceSettings(domainId){
    const params = new HttpParams()
      .set('domainId', domainId);
    return this.http.get<any>(this.apiUrl.apiForLoadMarketplaceSettings(), {'params': params});
  }

  apiForLoadInformedUsers(domainId){
    const params = new HttpParams()
      .set('domainId', domainId);
    return this.http.get<any>(this.apiUrl.apiForLoadInformedUsers(), {'params': params});
  }

  apiForLoadPaymentSetting(domainId){
    const params = new HttpParams()
      .set('domainId', domainId);
    return this.http.get<any>(this.apiUrl.apiForLoadPaymentSetting(), {'params': params});
  }

  apiForLoadEmailSetting(domainId){
    const params = new HttpParams()
      .set('domainId', domainId);
    return this.http.get<any>(this.apiUrl.apiForLoadEmailSetting(), {'params': params});
  }

  apiForShippingCost(domainId){
    const params = new HttpParams()
      .set('domainId', domainId);
    return this.http.get<any>(this.apiUrl.apiForLoadShippingCost(), {'params': params});
  }

  apiForEmailSettingUpdate(data: any) {
    return this.http.post<any>(this.apiUrl.apiForUpdateEmailSetting(), data);
  }

  duplicateQuizTopic(quizTopic: any) {
    return this.http.post<any>(this.apiUrl.apiDuplicateQuizTopic(), quizTopic);
  }

  apiForUserEmailDetail(email: any) {
    const params = new HttpParams()
      .set('email', email);
    return this.http.get<any>(this.apiUrl.apiForUserEmail(), {'params': params})
  }

  apiForManualTax(data: any) {
    return this.http.post<any>(this.apiUrl.apiManualTax(), data);
  }

  apiForTrainingTax(data: any) {
    return this.http.post<any>(this.apiUrl.apiTrainingTax(), data);
  }

  apiSendTwilioSms(data: any) {
    return this.http.post<any>(this.apiUrl.apiSendTwilioSms(), data);
  }

  apivalidateShippingAddress(data: any) {
    return this.http.post<any>(this.apiUrl.apivalidateShippingAddress(), data);
  }

  getPaymentkeys(data: any) {
    return this.http.post<any>(this.apiUrl.getPaymentkeys(), data);
  }

  setPaymentkeys(data: any) {
    return this.http.post<any>(this.apiUrl.setPaymentkeys(), data);
  }

  getCart(data: any) {
    return this.http.post<any>(this.apiUrl.apiForGetCart(), data);
  }

  updateCartItems(data: any) {
    return this.http.post<any>(this.apiUrl.updateCartItems(), data);
  }

  updateManualStatus(data: any) {
    return this.http.post<any>(this.apiUrl.updateManualStatus(), data);
  }

  updateQbItemStatus(data: any) {
    return this.http.post<any>(this.apiUrl.updateQbItemStatus(), data);
  }

  updateCartItemsWithDetails(data: any) {
    return this.http.post<any>(this.apiUrl.updateCartItemsWithDetails(), data);
  }

  emptyCart(data: any) {
    return this.http.post<any>(this.apiUrl.emptyCart(), data);
  }

  updateCartFormDetails(data: any) {
    return this.http.post<any>(this.apiUrl.updateCartForm(), data);
  }

  updateBusinessNewDetails(data: any) {
    return this.http.post<any>(this.apiUrl.updateBusinessNew(), data);
  }

  manageAutoshopSubscriber(data: any) {
    return this.http.post<any>(this.apiUrl.manageAutoshopSubscriber(), data);
  }

  getAutoshopSubscribers(data: any) {
    return this.http.post<any>(this.apiUrl.getAutoshopSubscribers(), data);
  }

  manageAutoshopSubscriberStatus(data: any) {
    return this.http.post<any>(this.apiUrl.manageAutoshopSubscriberStatus(), data);
  }

  emailAutoshopSubscribers(data: any) {
    return this.http.post<any>(this.apiUrl.emailAutoshopSubscribers(), data);
  }

  checkCustomerPhone(data: any) {
    return this.http.post<any>(this.apiUrl.checkCustomerPhone(), data);
  }

  checkCustomerName(data: any) {
    return this.http.post<any>(this.apiUrl.checkCustomerName(), data);
  }

  apiForManualUserEmailDetail(email: any) {
    const params = new HttpParams()
      .set('email', email);
    return this.http.get<any>(this.apiUrl.apiForManualUserEmail(), {'params': params})
  }

  deleteQuizTopic(id: any) {
    const params = new HttpParams()
      .set('id', id);
    return this.http.delete<any>(this.apiUrl.apiDeleteQuizTopic(), {'params': params});
  }

  createQuiz(quizTopic: any) {
    return this.http.post<any>(this.apiUrl.apiCreateQuiz(), quizTopic);
  }

  updateQuiz(quizTopic: any) {
    return this.http.post<any>(this.apiUrl.apiUpdateQuiz(), quizTopic);
  }

  listQuizTopic() {
    return this.http.get<any>(this.apiUrl.apiGetQuizTopic());
  }

  listQuizTopicWithRecords(domainId: any) {
    const params = new HttpParams()
    .set('domainId', domainId);
    return this.http.get<any>(this.apiUrl.apiGetQuizTopicWithRecords(), {'params': params});
  }

  updateDomainMarketPlace(marketPlaceData: any) {
    return this.http.post<any>(this.apiUrl.apiUpdateDomainMarketPlace(), marketPlaceData);
  }

  updateDomainBannerMarketPlace(marketPlaceData: any) {
    return this.http.post<any>(this.apiUrl.apiUpdateDomainBannerMarketPlace(), marketPlaceData);
  }

  updateRepairyDomainMarketPlace(marketPlaceData: any) {
    return this.http.post<any>(this.apiUrl.apiUpdateRepairfyDomainMarketPlace(), marketPlaceData);
  }

  apiUpdateMarketPlaceReminderFields(marketPlaceData: any) {
    return this.http.post<any>(this.apiUrl.apiUpdateMarketPlaceReminderFields(), marketPlaceData);
  }

  getTrainingEmails(marketPlaceData: any) {
    return this.http.post<any>(this.apiUrl.getTrainingEmails(), marketPlaceData);
  }

  getTransactionEmails(marketPlaceData: any) {
    return this.http.post<any>(this.apiUrl.getTransactionEmails(), marketPlaceData);
  }

  resendTrackingEmail(marketPlaceData: any) {
    return this.http.post<any>(this.apiUrl.resendTrackingEmail(), marketPlaceData);
  }

  processTransaction(marketPlaceData: any) {
    return this.http.post<any>(this.apiUrl.processTransaction(), marketPlaceData);
  }

  deleteMarketPlace(data: any) {
    const params = new HttpParams()
      .set('id', data.threadId)
      .set('domainId', data.domainId);
    return this.http.delete<any>(this.apiUrl.apiDeleteMarketPlace(), {'params': params});
  }

  deleteMarketPlacePermanent(data: any) {
    const params = new HttpParams()
      .set('id', data.threadId)
    return this.http.delete<any>(this.apiUrl.apiDeleteMarketPlacePermanent(), {'params': params});
  }

  deleteManualPermanent(data: any) {
    const params = new HttpParams()
      .set('id', data.threadId)
      .set('domainId', data.domainId);
    return this.http.delete<any>(this.apiUrl.apiDeleteManualPermanent(), {'params': params});
  }

  restoreMarketPlace(data: any, timezone_offset_minutes) {
    const params = new HttpParams()
      .set('id', data.threadId)
      .set('timeZoneMinutes', timezone_offset_minutes)
      .set('domainId', data.domainId);
    return this.http.get<any>(this.apiUrl.apiRestoreMarketPlace(), {'params': params});
  }

  deleteManual(data: any) {
    const params = new HttpParams()
      .set('id', data.threadId)
      .set('domainId', data.domainId);
    return this.http.delete<any>(this.apiUrl.apiDeleteManual(), { 'params': params });
  }

  restoreManual(data: any, timezone_offset_minutes) {
    const params = new HttpParams()
      .set('id', data.threadId)
      .set('domainId', data.domainId)
      .set('timeZoneMinutes', timezone_offset_minutes)
    return this.http.get<any>(this.apiUrl.apiRestoreManual(), { 'params': params });
  }

  setIsNewFalse(id: any, domainId: any) {
    const params = new HttpParams()
      .set('id', id)
      .set('domainId', domainId);
    return this.http.delete<any>(this.apiUrl.apiSetIsNewFalse(), {'params': params});
  }

  setIsNewFalseManual(id: any, domainId: any) {
    const params = new HttpParams()
      .set('id', id)
      .set('domainId', domainId)
    return this.http.delete<any>(this.apiUrl.apiSetIsNewFalseManual(), {'params': params});
  }

  deleteQuiz(id: any) {
    const params = new HttpParams()
      .set('id', id);
    return this.http.delete<any>(this.apiUrl.apiDeleteQuiz(), {'params': params});
  }

  userSubmitData(data: any) {
    return this.http.post<any>(this.apiUrl.apiCreateUserMarketPlace(), data);
  }

  userManualSubmitData(data: any) {
    return this.http.post<any>(this.apiUrl.apiCreateUserManualBooking(), data);
  }

  purchaseSeatsData(data: any) {
    return this.http.post<any>(this.apiUrl.apiPurchaseSeatsMarketPlace(), data);
  }

  userUpdateData(data: any) {
    return this.http.post<any>(this.apiUrl.apiUserInfoUpdate(), data);
  }

  manualUserUpdateData(data: any) {
    return this.http.post<any>(this.apiUrl.apiManualUserInfoUpdate(), data);
  }

  countryMasterData() {
    return this.http.get<any>(this.apiUrl.apiGetMasterData());
  }

  stateMasterData(countryId: any, domainId: any) {
    const params = new HttpParams()
      .set('domainId', domainId)
      .set('country_id', countryId);
    return this.http.get<any>(this.apiUrl.apiGetStateData(), {'params': params});
  }

  // Shipping Cost
  getShippingCost(domainId){
    return this.http.get<any>(this.apiUrl.apiGetMarketPlaceShippingCost(domainId));
  }

  getEmailNoticationsSettings(domainId){
    return this.http.get<any>(this.apiUrl.apiGetMarketPlaceEmailNoticationsSettings(domainId));
  }

  getEmailNoticationsSetting(domainId, type){
    return this.http.get<any>(this.apiUrl.apiGetMarketPlaceEmailNoticationsSetting(domainId, type));
  }

  updateEmailNoticationsSettings(data){
    return this.http.post<any>(this.apiUrl.apiUpdateMarketPlaceEmailNoticationsSettings(), data );
  }

  updateTextMessageToolip(domainId){
    return this.http.post<any>(this.apiUrl.apiUpdateTextMessageTooltip(), domainId );
  }

  updateMarketPlace(marketPlaceData: any) {
    return this.http.post<any>(this.apiUrl.apiUpdateMarketPlace(), marketPlaceData);
  }

  updateManual(marketPlaceData: any) {
    return this.http.post<any>(this.apiUrl.apiUpdateManual(), marketPlaceData);
  }

  // Thread Creation API
  createThread(threadData) {
    return this.http.post<any>(this.apiUrl.apiCreateThread(), threadData);
  }

  // Thread Update API
  updateThread(threadData) {
    return this.http.post<any>(this.apiUrl.apiUpdateThread(), threadData);
  }

  // Thread Push Api
  threadPush(pushData) {
    return this.http.post<any>(this.apiUrl.apiThreadPush(), pushData);
  }

  // Document/Announcement Update API
  updateTechInfo(data) {
    return this.http.post<any>(this.apiUrl.apiUpdateTechInfo(), data);
  }

  // Document Notification Api
  documentNotification(pushData) {
    return this.http.post<any>(this.apiUrl.apiDocumentNotification(), pushData);
  }

  // Document Notification Api
  documentApprovalNotification(pushData) {
    return this.http.post<any>(this.apiUrl.apiDocumentApprovalNotification(), pushData);
  }

  // ADAS Notification Api
  adasNotification(pushData) {
    return this.http.post<any>(this.apiUrl.apiADASNotification(), pushData);
  }

  // Manage Opportunity
  manageOpportunity(optData) {
    return this.http.post<any>(this.apiUrl.apiManageOpportunity(), optData);
  }

  //Shipping Cost
  updateShippingCost(optData){
    return this.http.post<any>(this.apiUrl.apiUpdateMarketPlaceShippingCost() , optData);
  }


  apiGetDomainMarketPlaceIndexData(data: any) {
    return this.http.post(this.apiUrl.apiGetDomainMarketPlaceData(), data);
  }

  getDomainMarketPlaceIndexData(domainId: any) {
      const params = new HttpParams()
      .set('domainId', domainId)
      .set('offset', '0')
      .set('limit', '1');
    return this.http.get<any>(this.apiUrl.apiGetDomainMarketPlaceData(), {'params': params});
  }

  //common function for payment formatting
  isInt(value, showCurrency = true, hideDecimal = false) {
    return !isNaN(value) && ((x) => {
      let val: any;
      if (((x | 0) === x) && hideDecimal) {
        val = x;
      } else {
        val = (Math.round(x * 100) / 100).toFixed(2);
      }
      // val = (Math.round(x * 100) / 100).toFixed(2);
      if (showCurrency) {
        return '$' + val;
      } else {
        return val;
      }
    })(parseFloat(value));
  }

  urlify(text: any) {
    return text;
    const urlRegex = /(https?:\/\/[^\< ]+)/g;
    return text.replace(urlRegex, (url: string) => {
      return `<a href="${url}" target="_blank">${url}</a>`;
    });
  }

  uploadExcelFile(file) {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post(this.apiUrl.uploadExcelFile(), formData, {
      reportProgress: true,
      headers: new HttpHeaders({ "Accept": "application/json" }),
      observe: 'events'
    });
  }

  getExcelFile() {
    return this.http.get(this.apiUrl.getExcelFile());
  }

  getExcelFileMasters() {
    return this.http.get(this.apiUrl.getExcelFileMasters());
  }

  updateExcelTableData(data:any) {
    return this.http.post(this.apiUrl.updateExcelTableData(),data);
  }

  apiGetProducts(data: any) {
    return this.http.post<any>(this.apiUrl.apiGetProducts(), data);
  }

  apiCreateSubscription(data: any) {
    return this.http.post<any>(this.apiUrl.apiCreateSubscription(), data);
  }

  apiSetupCard(data: any) {
    return this.http.post<any>(this.apiUrl.apiSetupCard(), data);
  }

  apiCreatecard(data: any) {
    return this.http.post<any>(this.apiUrl.apiCreatecard(), data);
  }

  apiDeletecard(data: any) {
    return this.http.post<any>(this.apiUrl.apiDeletecard(), data);
  }

  getPaymentMethods(data: any) {
    return this.http.post<any>(this.apiUrl.getPaymentMethods(), data);
  }

  setCreditcardPrimary(data: any) {
    return this.http.post<any>(this.apiUrl.setCreditcardPrimary(), data);
  }

  apiCancelSubscription(data: any) {
    return this.http.post<any>(this.apiUrl.apiCancelSubscription(), data);
  }

  apiResumeSubscription(data: any) {
    return this.http.post<any>(this.apiUrl.apiResumeSubscription(), data);
  }

  apiGetSubscription(data: any) {
    return this.http.post<any>(this.apiUrl.apiGetSubscription(), data);
  }

  apiGetsubscriptions(data: any) {
    return this.http.post<any>(this.apiUrl.apiGetsubscriptions(), data);
  }

  apiGetsubscriptionInvoiceDetail(data: any) {
    return this.http.post<any>(this.apiUrl.apiGetsubscriptionInvoiceDetail(), data);
  }
  
  getSubscriptionLogs(data: any) {
    return this.http.post<any>(this.apiUrl.getSubscriptionLogs(), data);
  }

  apiGetAutomatedMsg(data: any) {
    return this.http.post<any>(this.apiUrl.apiGetAutomatedMsg(), data);
  }

  apiGetSavedCard(data: any) {
    return this.http.post<any>(this.apiUrl.apiGetSavedCard(), data);
  }

  apiGetQbItems(data: any) {
    return this.http.post<any>(this.apiUrl.apiGetQbItems(), data);
  }

  apiUpdateQbItemPrice(data: any) {
    return this.http.post<any>(this.apiUrl.apiUpdateQbItemPrice(), data);
  }

  apiUpdateQbItemProductCode(data: any) {
    return this.http.post<any>(this.apiUrl.apiUpdateQbItemProductCode(), data);
  }

  apiGetQbItemDetails(data: any) {
    return this.http.post<any>(this.apiUrl.apiGetQbItemDetails(), data);
  }

  apiSetSlackChannels(data: any) {
    return this.http.post<any>(this.apiUrl.apiSetSlackChannels(), data);
  }

  apiRemoveSlackChannel(data: any) {
    return this.http.post<any>(this.apiUrl.apiRemoveSlackChannel(), data);
  }

  apiGetSlackChannels(domainId: any, code:any, redirectUrl: any) {
    return this.http.get<any>(this.apiUrl.apiGetSlackChannels(domainId, code, btoa(redirectUrl)));
  }

  apiGetSlack(data: any) {
    return this.http.post<any>(this.apiUrl.apiGetSlack(), data);
  }

  uploadReportsPdf(data: any) {
    return this.http.post<any>(this.apiUrl.uploadReportsPdf(), data);
  }

  updateTransactionSalesPerson(data: any) {
    return this.http.post<any>(this.apiUrl.updateTransactionSalesPerson(), data);
  }

  resendEmailFromReports(data: any) {
    return this.http.post<any>(this.apiUrl.resendEmailFromReports(), data);
  }

  addTrainingParticipant(data: any) {
    return this.http.post<any>(this.apiUrl.addTrainingParticipant(), data);
  }

  updateParticipantCompany(data: any) {
    return this.http.post<any>(this.apiUrl.updateParticipantCompany(), data);
  }

  resendPaymentFromReports(data: any) {
    return this.http.post<any>(this.apiUrl.resendPaymentFromReports(), data);
  }

  setreminderemailsettings(data: any) {
    return this.http.post<any>(this.apiUrl.setreminderemailsettings(), data);
  }

  getreminderemailsettings(data: any) {
    return this.http.post<any>(this.apiUrl.getreminderemailsettings(), data);
  }

  updatetransactionuser(data: any) {
    return this.http.post<any>(this.apiUrl.updatetransactionuser(), data);
  }

  updatetransactionuserdetail(data: any) {
    return this.http.post<any>(this.apiUrl.updatetransactionuserdetail(), data);
  }

  getReconciliationReport(data: any) {
    return this.http.post<any>(this.apiUrl.getReconciliationReport(), data);
  }

  urltobase64(data: any) {
    return this.http.post<any>(this.apiUrl.apiUrltobase64(), data);
  }

  getTrainingParticipant(data: any) {
    return this.http.post<any>(this.apiUrl.getTrainingParticipant(), data);
  }

  manageTransactionCompany(data: any) {
    return this.http.post<any>(this.apiUrl.manageTransactionCompany(), data);
  }

  apigetcompanyusersbyname(data: any) {
    return this.http.post<any>(this.apiUrl.apigetcompanyusersbyname(), data);
  }

  getTaxStates(data: any) {
    return this.http.post<any>(this.apiUrl.getTaxStates(), data);
  }
  
  getDataFromUrl(data: any) {
    return this.http.post<any>(this.apiUrl.getDataFromUrl(), data);
  }

  setTaxStates(data: any) {
    return this.http.post<any>(this.apiUrl.setTaxStates(), data);
  }

  updateSalesRep(data: any) {
    return this.http.post<any>(this.apiUrl.updateSalesRep(), data);
  }

  getAllSubscribersByDomain(data: any) {
    return this.http.post<any>(this.apiUrl.getAllSubscribersByDomain(), data);
  }

  getAllSubscribersDashboard(data: any) {
    return this.http.post<any>(this.apiUrl.getAllSubscribersDashboard(), data);
  }

  revenuePerMonth(data: any) {
    return this.http.post<any>(this.apiUrl.revenuePerMonth(), data);
  }
 
  classFillRate(data: any) {
    return this.http.post<any>(this.apiUrl.classFillRate(), data);
  }
  
  getSalesPerPricingTear() {
    return this.http.get<any>(this.apiUrl.getSalesPerPricingTear());
  }
  
  getTrainingByState() {
    return this.http.get<any>(this.apiUrl.getTrainingByState());
  }
  
  trainingFillRate(data: any) {
    return this.http.post<any>(this.apiUrl.trainingFillRate(), data);
  }
 
  trainingPerMonth(data: any) {
    return this.http.post<any>(this.apiUrl.trainingPerMonth(), data);
  }

  videoLibraryVideoThumbnail(data: any) {
    return this.http.post<any>(this.apiUrl.apiVideoCategoryImgfileUpload(), data);
  }

  removeTrainingParticipant(data: any) {
    return this.http.post<any>(this.apiUrl.removeTrainingParticipant(), data);
  }

  updateSalesPersonEmail(data: any) {
    return this.http.post<any>(this.apiUrl.updateSalesPersonEmail(), data);
  }

  getAllTrainings(data: any) {
    return this.http.post<any>(this.apiUrl.getAllTrainings(), data);
  }

  importExcel(data: any) {
    return this.http.post<any>(this.apiUrl.importExcel(), data);
  }

}
